export default __webpack_public_path__ + "static/media/project.49b5a3d1.jpg";